import { render, staticRenderFns } from "./AdminPost.vue?vue&type=template&id=70836846"
import script from "./AdminPost.vue?vue&type=script&lang=js"
export * from "./AdminPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports